import React, {ReactNode} from 'react';

interface Props {
    children: ReactNode;
    className?: string;
    variant?: 'default' | 'inset' | 'preview';
}

const ChartSettingsPanel = React.memo<Props>(({
    children,
    className = '',
    variant = 'default',
}) => (
    <div className={`chart-settings-panel chart-settings-panel--${variant}${className ? ` ${className}` : ''}`}>
        {children}
    </div>
));

export default ChartSettingsPanel;
